const POI_ACTION_TYPES = {
  ALTERNATE_ROUTE: 'ALTERNATE_ROUTE',
  POI_LIST: 'POI_LIST',
  POI_RESET: 'POI_RESET',
  STOPS: 'STOPS',
  INCOMING_STOP: 'INCOMING_STOP',
  REMOVE_STOPS: 'REMOVE_STOPS',
  FILTER: {
    APPLY: 'FILTER_APPLY',
    SAVE_LIST: 'FILTER_SAVE_LIST',
    SET: 'FILTER_SET',
  },
  POI_SELECTED: {
    LOADING: 'POI_SELECTED_LOADING',
    SUCCESS: 'POI_SELECTED_SUCCESS',
  },
  POI_FROM_WS: {
    LOADING: 'POI_FROM_WS_LOADING',
    SUCCESS: 'POI_FROM_WS_SUCCESS',
    ERROR: 'POI_FROM_WS_ERROR',
  },
  GET_POI_INFORMATION: {
    LOADING: 'GET_POI_INFORMATION_LOADING',
    SUCCESS: 'GET_POI_INFORMATION_SUCCESS',
    ERROR: 'GET_POI_INFORMATION_ERROR',
  },
  ROUTES_LIST_FROM_WS: {
    LOADING: 'ROUTES_LIST_FROM_WS_LOADING',
    SUCCESS: 'ROUTES_LIST_FROM_WS_SUCCESS',
    ERROR: 'ROUTES_LIST_FROM_WS_ERROR',
  },
  NAVIGATION_STATE: {
    ROUTE_INPROGRESS: 'NAVIGATION_STATE_ROUTE_IN_PROGRESS',
    SINGLE_POI: 'NAVIGATION_STATE_SINGLE_POI',
    ADD_STOP_INPROGRESS: 'NAVIGATION_STATE_ADD_STOP_INPROGRESS',
    POI_LIST_INPROGRESS: 'NAVIGATION_STATE_POI_LIST_INPROGRESS',
    EDIT_LIST_INPROGRESS: 'EDIT_LIST_INPROGRESS',
    FAVORITE_LIST_INPROGRESS: 'FAVORITE_LIST_INPROGRESS',
    RECENT_LIST_INPROGRESS: 'RECENT_LIST_INPROGRESS',
    QUICKLINKS_INPROGRESS: 'QUICKLINKS_INPROGRESS',
  },
  ROUTE_WAYPOINT_DETAILS: {
    LOADING: 'ROUTE_WAYPOINT_DETAILS_LOADING',
    SUCCESS: 'ROUTE_WAYPOINT_DETAILS_SUCCESS',
    ERROR: 'ROUTE_WAYPOINT_DETAILS_ERROR',
  },
  FAVORITE_LIST_FROM_WS: {
    LOADING: 'FAVORITE_LIST_FROM_WS_LOADING',
    SUCCESS: 'FAVORITE_LIST_FROM_WS_SUCCESS',
    ERROR: 'FAVORITE_LIST_FROM_WS_ERROR',
  },
  RECENT_LIST_FROM_WS: {
    LOADING: 'RECENT_LIST_FROM_WS_LOADING',
    SUCCESS: 'RECENT_LIST_FROM_WS_SUCCESS',
    ERROR: 'RECENT_LIST_FROM_WS_ERROR',
  },
  QUICKLINKS_FROM_WS: {
    LOADING: 'QUICKLINKS_FROM_WS_LOADING',
    SUCCESS: 'QUICKLINKS_FROM_WS_SUCCESS',
    ERROR: 'QUICKLINKS_FROM_WS_ERROR',
  },
  TURN_BY_TURN_FROM_WS: {
    LOADING: 'TURN_BY_TURN_FROM_WS_LOADING',
    SUCCESS: 'TURN_BY_TURN_FROM_WS_SUCCESS',
    ERROR: 'TURN_BY_TURN_FROM_WS_ERROR',
  },
};

export default POI_ACTION_TYPES;
